import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Response } from 'src/app/shared/models/response.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment.prod';
import { Empresa } from '../models/empresa';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  PHP_API_SERVER = environment.baseUrl;//"http://127.0.0.1:8080";
  // PHP_API_SERVER = "http://portaldedenuncias.azkenservices.com/backend/";
  constructor(private router: Router, private httpClient: HttpClient, private auth: AuthService) { }


  addCompany(id_sociedad: string, id_empresa: string, n_empresa: string, comentario: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/crearEmpresa.php`, {
      id_sociedad: id_sociedad,
      id_empresa: id_empresa,
      n_empresa: n_empresa,
      comentario: comentario
    }, options);
  }

  countComplaintByIdCompany(id_sociedad: string, id_empresa: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/contarDenunciasPorEmpresas.php`, {
      id_sociedad: id_sociedad,
      id_empresa: id_empresa
    }, options);
  }

  deleteCompanyByUser(id_sociedad: string, id_empresa: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/eliminarEmpresa.php`, {
      id_sociedad: id_sociedad,
      id_empresa: id_empresa,
    }, options);
  }
  updateCompanyByUser(id_sociedad: string, id_empresa: string, n_empresa: string, comentario: string) {
    const headers = { 'Authorization': 'Bearer ' + this.auth.getToken() }
    let options = { headers: headers };

    return this.httpClient.post(`${this.PHP_API_SERVER}/api/modificarEmpresa.php`, {
      id_sociedad: id_sociedad,
      id_empresa: id_empresa,
      n_empresa: n_empresa,
      comentario: comentario
    }, options);
  }
}
